import React from "react";
import resumeFile from "../documents/resume1.pdf";

const Resume = ({ classicHeader, darkTheme }) => {
  const educationDetails = [
    {
      yearRange: "2024 - 2025",
      title: "Full-Stack Developer",
      place: "Online (Evangadi Networks)",
      desc: "Completed an intensive full-stack development program focused on building scalable web applications using technologies such as React, Node.js, Express.js, and MongoDB. Gained hands-on experience with RESTful APIs, Git/GitHub, and modern frontend frameworks.",
    },
    {
      yearRange: "2005 - 2008",
      title: "Video Editor",
      place: "TOM Videographer",
      desc: "Edited a wide range of video content including weddings, promotional videos, and short films.  Managed color grading, transitions, and audio syncing to ensure high-quality output.",
    },
    {
      yearRange: "2010 - 2014",
      title: "Laboratory Technician",
      place: "Addis Ababa Medical College",
      desc: "Performed diagnostic tests, sample collection, and lab analysis following medical standards. Maintained accurate lab records and ensured the cleanliness and safety of lab equipment. Collaborated with healthcare professionals to support patient diagnosis and care.",
    },
  ];

  // const experienceDetails = [
  //   // {
  //   //   yearRange: "2012 - 2013",
  //   //   title: "Jr. UI UX Designer",
  //   //   place: "Themeforest",
  //   //   desc: "Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
  //   // },
  //   // {
  //   //   yearRange: "2014 - 2016",
  //   //   title: "Jr. Product Designer",
  //   //   place: "Dribbble",
  //   //   desc: "Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
  //   // },
  //   // {
  //   //   yearRange: "2017 - 2019",
  //   //   title: "Product Designer",
  //   //   place: "Adobe",
  //   //   desc: "Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
  //   // },
  // ];
  const experienceDetails = [
    {
      yearRange: "2024 - 2025",
      title: "Full-Stack Developer",
      place: "Evangadi Tech (Online)",
      desc: "Built full-stack applications using React, Node.js, and MongoDB. Focused on creating responsive front-end interfaces and scalable back-end APIs. Collaborated on real-world projects, followed agile methodologies, and received certification upon completion.",
    },
    {
      yearRange: "2020 - 2024",
      title: "Freelance Video Editor",
      place: "TOM Videographer",
      desc: "Edited various video projects including weddings, events, and promotional content. Used Adobe Premiere Pro and After Effects to deliver visually engaging edits. Worked directly with clients to ensure project satisfaction and creative vision.",
    },
    {
      yearRange: "2010 - 2014",
      title: "Laboratory Technician",
      place: "Addis Ababa Medical College",
      desc: "Conducted laboratory testing procedures, maintained lab equipment, and ensured compliance with safety protocols. Assisted in diagnostic processes by preparing samples and delivering accurate lab reports to support patient care.",
    },
  ];

  const skills = [
    // {
    //   name: "Web Design",
    //   percent: 65,
    // },
    // {
    //   name: "HTML/CSS",
    //   percent: 95,
    // },
    // {
    //   name: "JavaScript",
    //   percent: 80,
    // },
    // {
    //   name: "React JS",
    //   percent: 70,
    // },
    // {
    //   name: "Angular Js",
    //   percent: 60,
    // },
    // {
    //   name: "Bootstrap",
    //   percent: 99,
    // },
    { name: "React", icon: "fab fa-react", color: "#61DBFB" },
    { name: "HTML", icon: "fab fa-html5", color: "#e34c26" },
    { name: "CSS", icon: "fab fa-css3-alt", color: "#264de4" },
    { name: "JavaScript", icon: "fab fa-js-square", color: "#f0db4f" },
    { name: "Material UI", icon: "fas fa-layer-group", color: "#0081CB" },
    { name: "Bootstrap", icon: "fab fa-bootstrap", color: "#7952b3" },
    { name: "Tailwind CSS", icon: "fas fa-wind", color: "#38bdf8" },
    { name: "Node.js", icon: "fab fa-node-js", color: "#68a063" },
    { name: "Express.js", icon: "fas fa-server", color: "#404d59" },
    { name: "MongoDB", icon: "fas fa-database", color: "#4DB33D" },
    { name: "SQL", icon: "fas fa-table", color: "#336791" },
    { name: "Firebase", icon: "fas fa-fire", color: "#FFA611" },
    { name: "REST API", icon: "fas fa-plug", color: "#e67e22" },
    { name: "jQuery", icon: "fas fa-code", color: "#0769AD" },
    { name: "Git", icon: "fab fa-git-alt", color: "#f34f29" },
    { name: "GitHub", icon: "fab fa-github", color: "#000000" },
  ];

  return (
    <section
      id="resume"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Summary
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Resume
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gx-5">
          {/* My Education */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Education
            </h2>
            {educationDetails.length > 0 &&
              educationDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
          {/* My Experience */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Experience
            </h2>
            {experienceDetails.length > 0 &&
              experienceDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
        </div>
        {/* My Skills */}
        {/* <h2
          className={
            "text-6 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")
          }
        >
          My Skills
        </h2>
        <div className="row gx-5">
          {skills.length > 0 &&
            skills.map((skill, index) => (
              <div key={index} className="col-md-6">
                <p
                  className={
                    " fw-500 text-start mb-2 " +
                    (darkTheme ? "text-light" : "text-dark")
                  }
                >
                  {skill.name}{" "}
                  <span className="float-end">{skill.percent}%</span>
                </p>
                <div
                  className={
                    "progress progress-sm mb-4 " + (darkTheme ? "bg-dark" : "")
                  }
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: skill.percent + "%" }}
                    aria-valuenow={skill.percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            ))}
        </div> */}
        <h2
          className={
            "text-6 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")
          }
        >
          My Skills
        </h2>
        <div className="row gx-4 gy-3">
          {skills.map((skill, index) => (
            <div
              key={index}
              className="col-6 col-md-4 col-lg-2 d-flex align-items-center"
            >
              <i
                className={`${skill.icon} me-2`}
                style={{
                  fontSize: "1.5rem",
                  color: skill.color,
                  minWidth: "24px",
                }}
              />
              <span className={darkTheme ? "text-light" : "text-dark"}>
                {skill.name}
              </span>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <a
            className="btn btn-outline-secondary rounded-pill shadow-none"
            href={resumeFile}
            download
          >
            Download CV
            <span className="ms-1">
              <i className="fas fa-download" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Resume;
